// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"775":"e4ac3fae","924":"972cc03b"}[chunkId] + ".chunk.js";
};